<template>
<DropdownModal
  v-if="hasUser"
  :active.sync="active"
  strategy="fixed"
  :offset="[0, 25]"
  :overlay="true"
  :arrow="true"
>
  <template #toggle>
    <slot
      name="toggle"
      v-bind="commonSlotProps"
      :onClick="() => {}"
      :active="active"
    ></slot>
  </template>
  <ul slot="content" class="user-dropdown">
    <li
      class="
        user-dropdown__item
        user-dropdown__item--special
        user-dropdown__item-bonuses
      "
    >
      <IconGift class="icon"/>
      <span>Бонусы – {{ bonusesValue }}</span>
    </li>
    <li class="user-dropdown__item">
      <router-link
        :to="{ name: 'dashboard' }"
        @click.native="active = false"
      >
        <IconUser class="icon"/>
        <span>Личный кабинет</span>
      </router-link>
    </li>
    <li class="user-dropdown__item">
      <router-link
        :to="{ name: 'orders' }"
        @click.native="active = false"
      >
        <IconBasket class="icon"/>
        <span>Мои заказы</span>
      </router-link>
    </li>
    <li v-if="hasReferralProgram" class="user-dropdown__item">
      <a :href="referralProgram.invite_url" target="_blank">
        <IconReferral class="icon"/>
        <span>Пригласить друга</span>
      </a>
    </li>
    <li class="user-dropdown__item">
      <router-link
        :to="{ name: 'addresses.list' }"
        @click.native="active = false"
      >
        <IconMapMarker2 class="icon"/>
        <span>Мои адреса</span>
      </router-link>
    </li>
    <li class="user-dropdown__item">
      <button @click="() => { active = false; $store.dispatch('auth/logout') }">
        <IconLogout class="icon"/>
        <span>Выйти</span>
      </button>
    </li>
  </ul>
</DropdownModal>
<div v-else>
  <slot
    name="toggle"
    v-bind="commonSlotProps"
    :onClick="() => $store.commit('ui/toggleAuthModal')"
    :active="authModalIsActive"
  >Войти</slot>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    DropdownModal: () => import('@/components/modals/DropdownModal'),

    IconGift: () => import('@/assets/images/icons/icon-gift.svg?inline'),
    IconLogout: () => import('@/assets/images/icons/icon-logout.svg?inline'),
    IconMapMarker2: () => import('@/assets/images/icons/icon-map-marker-2.svg?inline'),
    IconUser: () => import('@/assets/images/icons/icon-user.svg?inline'),
    IconBasket: () => import('@/assets/images/icons/icon-basket.svg?inline'),
    IconReferral: () => import('@/assets/images/icons/icon-referral.svg?inline'),
  },
  props: {
    // Not used anywhere, just so the developer does not forget to perform that check.
    authenticationEnabled: {
      type: Boolean,
      required: true,
      validator: v => {
        if (!v) {
          console.warn('User modal must not be rendered when authentication is disabled');
          return false;
        }
        return true;
      },
    },
  },
  computed: {
    ...mapGetters({
      hasUser: 'auth/hasUser',
      authModalIsActive: 'ui/authModalIsActive',
      loyaltyProfile: 'auth/loyaltyProfile',
      referralProgram: 'auth/referralProgram',
    }),

    commonSlotProps() {
      return {
        authenticated: this.hasUser,
        user: this.$store.state.auth.user,
      };
    },

    bonusesValue() {
      if (!this.loyaltyProfile) {
        return '...'
      }

      return `${this.loyaltyProfile.balance.short} ${this.loyaltyProfile.balance.currency.symbol}`
    },

    hasReferralProgram() {
      return !!this.referralProgram && this.referralProgram.invite_url
    },
  },
  data() {
    return {
      active: false,
    };
  },
}
</script>

<style lang="less">
.user-dropdown {
  // Increased specificity because styles are leaking from `HeaderNonMobile.vue`.
  .user-dropdown__item.user-dropdown__item {
    @apply block text-sm text-light-darkest font-light;
    &:not(.user-dropdown__item--special) {
      > * {
        @apply w-full px-4 py-2 text-left flex items-center;
        font-weight: inherit;
        &:hover {
          @apply bg-primary-lightest text-primary;
        }
        border-radius: inherit; // So it does not overflow the parent when we change the background color.
      }
    }
    .icon {
      @apply w-6 mr-4 opacity-60;
    }
    &:not(:last-child) {
      @apply border-b border-light;
    }
    &:first-child {
      @apply rounded-b;
    }
    &:last-child {
      @apply rounded-b;
    }
    &.user-dropdown__item-bonuses {
      @apply p-4 text-base flex items-center;
      svg.icon {
        @apply fill-current text-primary opacity-100;
      }
    }
  }
}
</style>
